import React from 'react';
import {
  TextInput,
  Group,
  Button,
  Grid,
  Flex,
  MultiSelect,
  Stack
} from '@mantine/core';
import {
  IconSearch
} from '@tabler/icons-react';
import { DateInput } from '@mantine/dates';

const FiltroTermos = ({
  form,
  handleFilter,
  clearFilter
}) => {
  const opcoesTermos = [
    { value: '1', label: 'Termo de Apreensão e Depósito' },
    { value: '3', label: 'Termo de Notificação' },
    { value: '5', label: 'Termo de Destruição' },
    { value: '6', label: 'Termo de Guarda de Animal' },
    { value: '8', label: 'Termo de Incineração' },
    { value: '9', label: 'Termo de Doação' },
    { value: '10', label: 'Termo de Entrega Voluntária' },
    { value: '11', label: 'Termo de Soltura' },
    { value: '12', label: 'Termo de Apreensão' },
    { value: '13', label: 'Termo de Depósito' },
    { value: '14', label: 'Relatório de Fiscalização' },
    { value: '2', label: 'Termo de Substituição de Guarda e Depósito' },
    { value: '7', label: 'Termo de Embargo e Interdição' }
  ];

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
        handleFilter()
    }
}

  return (
    <Stack onKeyDown={handleKeyDown}>
      <Grid mb="md">
        <Grid.Col span={12}>
          <Flex
            direction={{ base: 'column', sm: 'row' }}
            gap="sm"
            align={{ base: 'stretch', sm: 'flex-end' }}
          >
            <TextInput
              placeholder="Pesquise por nome/razão social, CPF ou palavra-chave"
              {...form.getInputProps('pesquisaRapida')}
              rightSection={<IconSearch size={16} />}
              style={{ flex: 1 }}
            />
            <Group spacing="xs">
              <Button
                color="green"
                fw={'lighter'}
                radius={'xl'}
                onClick={handleFilter}
              >
                Aplicar filtros
              </Button>
              <Button
                color="green"
                variant="subtle"
                fw={'lighter'}
                radius={'xl'}
                onClick={clearFilter}
              >
                Limpar
              </Button>
            </Group>
          </Flex>
        </Grid.Col>
      </Grid>

      <Grid mb="md">
        <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
          <TextInput
            label="Município:"
            {...form.getInputProps('municipio')}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
          <TextInput
            label="Número do termo:"
            {...form.getInputProps('numeroTermo')}
          />
        </Grid.Col>

        <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
          <DateInput
            label="Período Inicial:"
            {...form.getInputProps('dataInicio')}
            styles={{
              calendarHeaderControl: {
                width: '30px',
                height: '30px'
              }
            }}
            placeholder={'DD/MM/AAAA'}
            size="sm"
            maxLength={10}
            dateParser={value => {
              const data = value.replace(/\D/g, '')
              if (data.length !== 8) {
                return null
              }
              const dia = Number(data.slice(0, 2))
              const mes = Number(data.slice(2, 4)) - 1
              const ano = Number(data.slice(4, 8))
              if (
                typeof dia === 'number' &&
                typeof mes === 'number' &&
                typeof ano === 'number'
              ) {
                return new Date(ano, mes, dia)
              }
              return null
            }}
            maxDate={new Date()}
            valueFormat="DD/MM/YYYY"
            locale="pt-br"
            onKeyDown={e => {
              const input = e.target
              const value = input.value
              const length = value.length
              const key = e.key
              const nextCharIsNumber = /\d/.test(key)
              if (
                nextCharIsNumber &&
                (length === 2 || length === 5) &&
                value[length - 1] !== '/'
              ) {
                input.value = value + '/' + e.key
                e.preventDefault()
              }
            }}
            clearable
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
          <DateInput
            label="Período Final:"
            {...form.getInputProps('dataFim')}
            styles={{
              calendarHeaderControl: {
                width: '30px',
                height: '30px'
              }
            }}
            placeholder={'DD/MM/AAAA'}
            size="sm"
            maxLength={10}
            dateParser={value => {
              const data = value.replace(/\D/g, '')
              if (data.length !== 8) {
                return null
              }
              const dia = Number(data.slice(0, 2))
              const mes = Number(data.slice(2, 4)) - 1
              const ano = Number(data.slice(4, 8))
              if (
                typeof dia === 'number' &&
                typeof mes === 'number' &&
                typeof ano === 'number'
              ) {
                return new Date(ano, mes, dia)
              }
              return null
            }}
            maxDate={new Date()}
            valueFormat="DD/MM/YYYY"
            locale="pt-br"
            onKeyDown={e => {
              const input = e.target
              const value = input.value
              const length = value.length
              const key = e.key
              const nextCharIsNumber = /\d/.test(key)
              if (
                nextCharIsNumber &&
                (length === 2 || length === 5) &&
                value[length - 1] !== '/'
              ) {
                input.value = value + '/' + e.key
                e.preventDefault()
              }
            }}
            clearable
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
          <MultiSelect
            label="Tipo Termo:"
            placeholder="Selecione os tipos"
            data={opcoesTermos}
            {...form.getInputProps('idsTiposTermo')}
            searchable
            clearable
            size="sm"
            styles={{
              input: {
                minHeight: '36px'
              }
            }}
          />
        </Grid.Col>
      </Grid>
    </Stack>
  );
};

export default FiltroTermos;
